import "../../assets/css/policy/PrivacyPolicy.css";
import modalclose from "../../assets/img/ModalClose.svg";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const onClose = () => navigate(-1);
  const stop = (e) => e.stopPropagation();

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div
      className="pp-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="개인정보처리방침"
    >
      <div className="pp-box" onClick={stop}>
        <div className="pp-top">
          <div className="pp-title">개인정보처리방침</div>

          <button
            className="pp-close-button"
            onClick={onClose}
            aria-label="닫기"
            type="button"
          >
            <img src={modalclose} className="pp-modalclose-img" alt="닫기" />
          </button>
        </div>

        <div className="pp-divider" aria-hidden="true" />

        <div className="pp-des-all">
          <div className="pp-des">
            본 방침은 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를
            보호하고 이와 관련한 문제를 신속하고 원활하게 처리하기 위하여
            다음과 같이 수립하고 공개합니다.
          </div>

          <div className="pp-des">
            <strong>1. 개인정보의 처리 목적 및 수집 항목</strong>
            <br />
            본 사이트는 이용자의 개인정보를 직접 수집하지 않으나, 원활한 운영을
            위해 아래와 같이 최소한의 정보를 처리합니다.
            <br />
            <br />
            관리자(계정) 관리: 각 단위 관리자 계정 생성 및 관리를 위한 단위별
            관리자 계정 아이디, 비밀번호 수집 및 보관
            <br />
            활동 정보 공시: 총학생회 관련 정보 제공을 위한 관계 인원의 성명 및
            소속 정보 게시
          </div>

          <div className="pp-des">
            <strong>2. 자동 수집 항목 및 목적</strong>
            <br />
            사이트 이용 과정에서 외부 서비스(YouTube, Google Map,
            Instagram, KakaoTalk, 덕성여자대학교 홈페이지 등) 사용 시 
            아래와 같은 정보가 자동으로 생성되어 수집될 수 있습니다.
            <br />
            <br />
            수집 항목: IP 주소, 브라우저 정보, 방문 기록, 접속 로그, 접속
            모바일 운영체제 정보 등
            <br />
            수집 목적: 콘텐츠 제공, 사이트 서비스 품질 향상 및 보안 유지
            <br />
            수집 방식: 쿠키 및 외부 스크립트를 통한 자동 수집
            <br />
            관리 및 보유: 본 사이트는 해당 정보를 직접 저장하거나 관리하지
            않으며, 외부 서비스 제공업체의 정책에 따라 보유 및 처리됩니다.
          </div>

          <div className="pp-des">
            <strong>3. 개인정보의 보유 및 이용기간</strong>
            <br />
            관리자(계정) 정보: 해당 직책의 임기 종료 시 또는 관리 권한 회수
            시까지 보유하며, 목적 달성 후 지체 없이 파기합니다.
          </div>

          <div className="pp-des">
            <strong>4. 개인정보의 파기 절차 및 방법</strong>
            <br />
            개인정보가 불필요하게 되었을 때에는 지체 없이 해당 정보를
            파기합니다. 전자적 파일 형태는 기록을 재생할 수 없도록 기술적 방법을
            사용하여 삭제합니다.
          </div>

          <div className="pp-des">
            <strong>5. 정보주체의 권리 및 행사 방법</strong>
            <br />
            이용자는 언제든지 자신의 개인정보 열람·정정·삭제·처리 정지 요구
            등의 권리를 행사할 수 있습니다. 권리 행사는 하단에 안내된 이메일을
            통해 가능하며, 총학생회는 이에 대해 지체 없이 조치할 의무가
            있습니다.
          </div>

          <div className="pp-des">
            <strong>6. 개인정보 보호책임자 및 기타 구제 방법</strong>
            <br />
            개인정보 보호책임자: 덕성여자대학교 총학생회
            <br />
            이메일 주소: stdcouncil@duksung.ac.kr
            <br />
            기타 구제 방법: 개인정보침해신고센터 118 (privacy.kisa.or.kr)
          </div>

          <div className="pp-des">
            <strong>부칙</strong>
            <br />
            본 방침은 본 사이트 배포일부터 적용됩니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;